var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/elipsis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/elipsis",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF142",
    transform: "translate(10.031250, 4.656250)",
    fill: "#373A37",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96875,11.25 C2.53125,11.2734375 3,11.4609375 3.375,11.8125 L3.375,11.8125 C3.7265625,12.1875 3.9140625,12.65625 3.9375,13.21875 C3.9140625,13.78125 3.7265625,14.25 3.375,14.625 C3,14.9765625 2.53125,15.1640625 1.96875,15.1875 C1.40625,15.1640625 0.9375,14.9765625 0.5625,14.625 C0.2109375,14.25 0.0234375,13.78125 0,13.21875 C0.0234375,12.65625 0.2109375,12.1875 0.5625,11.8125 C0.9375,11.4609375 1.40625,11.2734375 1.96875,11.25 Z M1.96875,5.625 C2.53125,5.6484375 3,5.8359375 3.375,6.1875 L3.375,6.1875 C3.7265625,6.5625 3.9140625,7.03125 3.9375,7.59375 C3.9140625,8.15625 3.7265625,8.625 3.375,9 C3,9.3515625 2.53125,9.5390625 1.96875,9.5625 C1.40625,9.5390625 0.9375,9.3515625 0.5625,9 C0.2109375,8.625 0.0234375,8.15625 0,7.59375 C0.0234375,7.03125 0.2109375,6.5625 0.5625,6.1875 C0.9375,5.8359375 1.40625,5.6484375 1.96875,5.625 Z M3.9375,1.96875 C3.9140625,2.53125 3.7265625,3 3.375,3.375 L3.375,3.375 C3,3.7265625 2.53125,3.9140625 1.96875,3.9375 C1.40625,3.9140625 0.9375,3.7265625 0.5625,3.375 C0.2109375,3 0.0234375,2.53125 0,1.96875 C0.0234375,1.40625 0.2109375,0.9375 0.5625,0.5625 C0.9375,0.2109375 1.40625,0.0234375 1.96875,0 C2.53125,0.0234375 3,0.2109375 3.375,0.5625 C3.7265625,0.9375 3.9140625,1.40625 3.9375,1.96875 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipsis);
export default __webpack_public_path__ + "static/media/elipsis.5f2cd980fdd37abee54f82fa4ef79868.svg";
export { ForwardRef as ReactComponent };